"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DonutFiller = exports.DonutFillerTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var enums_1 = require("../../enums");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var DonutFillerTypes;
(function (DonutFillerTypes) {
    DonutFillerTypes["PRIMARY"] = "primary";
    DonutFillerTypes["PRIMARY_1"] = "primary-1";
    DonutFillerTypes["PRIMARY_2"] = "primary-2";
    DonutFillerTypes["PRIMARY_3"] = "primary-3";
    DonutFillerTypes["SECONDARY"] = "secondary";
    DonutFillerTypes["TERTIARY"] = "tertiary";
    DonutFillerTypes["DANGER"] = "danger";
    DonutFillerTypes["WARNING"] = "warning";
    DonutFillerTypes["SUCCESS"] = "success";
    DonutFillerTypes["INDICATION_ACCENT_1"] = "indicator-accent-1";
    DonutFillerTypes["INDICATION_ACCENT_2"] = "indicator-accent-2";
    DonutFillerTypes["INDICATION_ACCENT_3"] = "indicator-accent-3";
    DonutFillerTypes["GRAY"] = "gray";
})(DonutFillerTypes = exports.DonutFillerTypes || (exports.DonutFillerTypes = {}));
function getDonutRadius(size) {
    switch (size) {
        case enums_1.Enums.UiSizes.XXS:
            return 20;
        case enums_1.Enums.UiSizes.XS:
            return 30;
        case enums_1.Enums.UiSizes.SM:
            return 40;
        case enums_1.Enums.UiSizes.MD:
            return 50;
        case enums_1.Enums.UiSizes.LG:
            return 60;
        default:
            return 30;
    }
}
var DonutFiller = function (props) {
    var RADIUS = getDonutRadius(props.size);
    var VIEWPORT = RADIUS * 2 + 8;
    var CIRCUMFERENCE = 2 * Math.PI * RADIUS;
    var progress = props.percent;
    var dashoffset = CIRCUMFERENCE * (1 - progress);
    var cls = (0, BootstrapHelper_1.B)()
        .bl("donut-filler")
        .pmod(props.size || enums_1.Enums.UiSizes.SM)
        .pmod(props.type || "primary").bem;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "".concat(props.className || "", " ").concat(cls) }, { children: (0, jsx_runtime_1.jsxs)("svg", __assign({ className: "donut-filler__svg", width: VIEWPORT, height: VIEWPORT }, { children: [(0, jsx_runtime_1.jsx)("circle", { className: "donut-filler__circle donut-filler__meter", cx: VIEWPORT / 2, cy: VIEWPORT / 2, r: RADIUS }), (0, jsx_runtime_1.jsx)("circle", { className: "donut-filler__circle donut-filler__value", style: {
                        strokeDashoffset: dashoffset,
                        strokeDasharray: CIRCUMFERENCE
                    }, cx: VIEWPORT / 2, cy: VIEWPORT / 2, r: RADIUS })] })) })));
};
exports.DonutFiller = DonutFiller;
